import { TableProps } from 'antd';
import CustomTable from '../atoms/CustomTable';
import { ActionCode } from '@/store/services/configLogsService';
import { useTranslation } from 'react-i18next';

import { ChangedValue } from './AdminLogDetailsPopup';
import BusinessCardAttachment from '../Home/BusinessCardAttachments';
import InfoText from '../atoms/InfoText';

export interface ChangeItem extends ChangedValue {
  oldDocument?: { name: string; url: string } | null;
  newDocument?: { name: string; url: string } | null;
  url?: string | null;
}

export interface ChangesTableProps {
  response?: ChangeItem[];
  actionCode?: string;
  title?: string;
}

export default function ChangesTable({
  response,
  actionCode,
  title,
}: ChangesTableProps) {
  const { t } = useTranslation();
  const changedValues = response || [];

  const columns: TableProps['columns'] = [
    {
      title: t('configLogs.fieldName'),
      dataIndex: 'fieldName',
      key: 'fieldName',
    },

    //Incase of UPDATE and DELETE
    [ActionCode.UPDATE, ActionCode.DELETE].includes(
      actionCode as ActionCode
    ) && {
      title:
        actionCode === ActionCode.DELETE
          ? t('configLogs.value')
          : t('configLogs.oldValue'),
      dataIndex: 'oldValue',
      key: 'oldValue',
    },

    //Incase of UPDATE and CREATE
    [ActionCode.UPDATE, ActionCode.CREATE].includes(
      actionCode as ActionCode
    ) && {
      title: t('configLogs.newValue'),
      dataIndex: 'newValue',
      key: 'newValue',
    },
  ].filter(Boolean);

  const dataSource =
    changedValues?.map((i: ChangeItem) => ({
      fieldName: i.attribute,
      oldValue:
        i.type === 'TEXT' ? (
          i.oldValue
        ) : !!i.oldDocument ? (
          <BusinessCardAttachment
            title=""
            attachments={[
              {
                name: i.oldDocument?.name,
                blobFileUrl: i.oldDocument?.url,
                profileId: i.oldDocument?.url,
                blobSize: 0,
              },
            ]}
            withoutMargin
          />
        ) : (
          '-'
        ),
      newValue:
        i.type === 'TEXT' ? (
          i.newValue
        ) : !!i.newDocument ? (
          <BusinessCardAttachment
            title=""
            attachments={[
              {
                name: i.newDocument?.name,
                blobFileUrl: i.newDocument?.url,
                profileId: i.newDocument?.url,
                blobSize: 0,
              },
            ]}
            withoutMargin
          />
        ) : (
          '-'
        ),
      url: i.url || i.document,
      type: i.type,
    })) || [];

  return (
    <div>
      {title && <InfoText text={title} className="font-bold text-lg" />}

      <CustomTable
        rowKey="fieldName"
        columns={columns}
        dataSource={dataSource}
        currentPage={0}
        totalElements={dataSource.length}
        onPageChange={() => {}}
        pagination={false}
        tableLayout="fixed"
      />
    </div>
  );
}
